import type { CreateConnectorFn } from "wagmi"
import type { WalletConnectParameters } from "wagmi/connectors"
import { walletConnect } from "wagmi/connectors"

/**
 * Added as a workaround for OOM build issues seen in vercel when using walletConnect
 */
export const walletConnectConnector: (
  params: WalletConnectParameters,
) => CreateConnectorFn = params => {
  const baseCreateConnectorFn = walletConnect({
    ...params,
    qrModalOptions: {
      themeVariables: {
        "--wcm-z-index": "9999999",
      },
    },
  })
  return config => {
    const baseConnector = baseCreateConnectorFn(config)
    const originalSetupFn = baseConnector.setup
    baseConnector.setup = async () => {
      // No-op when not in a browser environment
      if (typeof document === "undefined") {
        return
      }
      await originalSetupFn?.call(baseConnector)
    }
    return baseConnector
  }
}
